import { BaseEdge, EdgeLabelRenderer, getBezierPath } from "@xyflow/react";

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  data,
  markerEnd,
}: {
  id: string;
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  data: any;
  markerEnd: string;
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} />

      <EdgeLabelRenderer>
        {data?.label && (
          <div
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              padding: "2px 5px",
              background: "#D7DAE7",
              color: "#7D808F",
              borderRadius: "8px",
              fontSize: "10px",
              fontWeight: "bold",
              whiteSpace: "nowrap",
              boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.1)",
            }}
            className="nodrag nopan">
            {data?.label}
          </div>
        )}
      </EdgeLabelRenderer>
    </>
  );
};

export default CustomEdge;
